import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import PhoneIcon from '@mui/icons-material/Phone';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import Popup2290 from '@/components/ui/2290Popup';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Form2290DownloadTemplatePopup from '@/components/ui/Form2290DownloadTemplatePopup';
import Form2290ExcelTemplateContactUs from '@/components/ui/Form2290ExcelTemplateContactUs';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
declare global {
  interface Window {
    Tawk_API: {
      maximize: () => void;
      minimize: () => void;
      toggle: () => void;
      showWidget: () => void;
      hideWidget: () => void;
      popup: () => void;
      onLoad?: () => void;
    };
  }
}
const FileForm2290Phone = () => {
  const [open, setOpen] = useState(false);
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [isForm2290Template, setIsForm2290Template] = useState(false);

  // const [isvideoPopupAuto, setvideoPopupAuto] = useState(false);

  // const openPopupSteps = () => {
  //   setvideoPopupSteps(true);
  // };

  // const [visible, setVisible] = useState(false);

  // const { ref, inView } = useInView({
  //   threshold: 0.2,
  //   triggerOnce: false, // change to true if you only want to animate once
  // });

  // useEffect(() => {
  //   setVisible(inView);
  // }, [inView]);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: 'Need to claim a refund using Form 8849?',
  //   SubHeading:
  //     'File it hassle-free and get your money back. E-file now for a quick refund.',
  //   CtaText: 'E-file Form 8849 Now',
  //   CtaSubHeading: `Get your refund now`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290sticky`,
  //   isActive: true,
  // };

  const openChat = () => {
    window.Tawk_API?.maximize();
  };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 8, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 8, 31)
      );
    }, 1000);
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
            color: '#fff',
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            color: '#fff',
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
            color: '#d7d7d7',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="File Form 2290 by Phone | Get IRS-stamped Schedule 1 Fast"
          description="File Form 2290 by phone with expert assistance. Fast HVUT filing, secure IRS e-filing, instant Schedule 1 delivery, and support for every fleet size."
          keywords=""
          canonical="excise-tax/file-irs-form-2290-by-phone/"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
          ogShareImg="assets/images/excise-share-img.png"
        />
      }
    >
      <ExciseSubMenu />
      <Popup2290 />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Form2290ExcelTemplateContactUs
        isOpenPopUp={isOpenPopUp}
        setIsOpenPopUp={setIsOpenPopUp}
      />
      <Form2290DownloadTemplatePopup
        isForm2290Template={isForm2290Template}
        setIsForm2290Template={setIsForm2290Template}
      />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 2,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #3d405b, #0d2b2f)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                color: '#d7d7d7ff',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 Deadline Has Passed!</strong> File{' '}
              <b style={{ color: '#fff', fontWeight: 600 }}>
                Form 2290 (2026–27) Now{' '}
              </b>
              to Avoid Further{' '}
              <b style={{ color: '#fff', fontWeight: 600 }}>Penalties.</b>
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time Left Until the Deadline:
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=2290app`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#0a7581',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File Form 2290 by{' '}
                <span className="highlight-container">
                  <span className="highlight">Phone – Fast </span>
                </span>{' '}
                IRS HVUT Filing Assistance
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Call us and our experts handle your Heavy Vehicle Use Tax filing
                from start to finish. Receive your{' '}
                <span style={{ fontWeight: 600 }}> IRS-Stamped Schedule 1</span>{' '}
                in minutes.
              </Typography>
              <Box
                sx={{
                  my: 1,
                  mb: 0,
                  gap: { xs: 0, sm: 4 },
                  display: { xs: 'grid', sm: 'flex' },
                  gridAutoColumns: 'auto auto',
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href="tel:+1(408) 444-7120"
                >
                  {' '}
                  <PhoneIcon sx={{ fontSize: 32, ml: -1.2, mr: 1.2 }} /> (408)
                  444-7120
                </Button>
                <Button
                  onClick={openChat}
                  startIcon={
                    <QuestionAnswerIcon
                      sx={{
                        fontSize: '32px !important',
                        color: 'rgb(29, 169, 74)',
                        ml: -1.2,
                        mr: 1.2,
                      }}
                    />
                  }
                  // variant="contained"
                  // className="secondary-btn"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    px: 5,
                    border: '2px solid rgb(29, 169, 74)',
                    borderRadius: 6,
                    color: 'rgb(29, 169, 74)',
                    fontSize: '24px',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  // className="btn-primary"
                  // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                >
                  Start Live Chat
                </Button>
              </Box>
              <Stack
                direction={{ md: 'row' }}
                spacing={{ xs: 1, md: 2 }}
                justifyContent={{
                  xs: 'left',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#f0f2f9',
                      borderRadius: '50%',
                      height: 60,
                      width: 60,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/fleet-icon.webp"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/fleet-icon.png"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/fleet-icon.png"
                        loading="lazy"
                        alt="100,000+ truckers trust TaxZerone"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, lineHeight: 1.1 }}
                  >
                    100,000+ truckers <br /> trust TaxZerone
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  {' '}
                  <Box
                    sx={{
                      backgroundColor: '#f0f2f9',
                      borderRadius: '50%',
                      height: 60,
                      width: 60,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/secure-icon.webp"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/secure-icon.png"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/secure-icon.png"
                        loading="lazy"
                        alt="Secure filing"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, lineHeight: 1.1 }}
                  >
                    Secure filing
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#f0f2f9',
                      borderRadius: '100%',
                      height: 60,
                      width: 60,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/instant-icon.webp"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/instant-icon.png"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/instant-icon.png"
                        loading="lazy"
                        alt="Instant Schedule 1"
                        className="mw-100"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, lineHeight: 1.1 }}
                  >
                    Instant Schedule 1
                  </Typography>
                </Box>
              </Stack>
              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    sx={{
                      '&.btn-primary.medium': {
                        fontSize: {
                          xs: '15px !important',
                          sm: '20px  !important',
                          md: '17px !important',
                          lg: '20px !important',
                        },
                      },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    Start Filing Now
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Just{' '}
                    <span style={{ color: '#1da94a', fontWeight: 600 }}>
                      $19.99 per
                    </span>{' '}
                    return
                  </Typography>
                </Box>
                <Hidden mdDown>
                  <Box
                    sx={{
                      mb: { xs: '16px !important', sm: '22px !important' },
                    }}
                  >
                    <picture>
                      <source
                        srcSet="/assets/images/irs-authorized.webp"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <source
                        srcSet="/assets/images/irs-authorized.png"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <img
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                    </picture>
                  </Box>
                </Hidden>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              //  className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/file-phone-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/file-phone-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/file-phone-landing-img.png"
                  alt="File Form 2290 by Phone – Fast IRS HVUT Filing Assistance"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              //  className="excise-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/file-phone-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/file-phone-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/file-phone-landing-img-sm.png"
                  alt="File Form 2290 by Phone – Fast IRS HVUT Filing Assistance"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                How 2290 Phone Filing Works?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 2,
                  fontSize: { md: 20, sm: 17, xs: 16 },
                  fontWeight: 400,
                }}
              >
                One phone call is all it takes to file your{' '}
                <Link
                  href="/resources/excise-tax/form-2290-instructions/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  Form 2290 online
                </Link>
                .
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Our experts handle everything and submit it directly to the IRS
                on your behalf.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} p={2} sx={{ justifyContent: 'center' }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,

                  px: 4,
                  backgroundColor: '#fff',
                  borderRadius: 6,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    backgroundColor: 'rgb(30, 190, 65, 0.5)',
                    display: 'inline-block',
                    p: ' 6px 15px',
                    borderRadius: 1.5,
                    fontWeight: 500,
                    color: '#2e2e2e',
                    my: 2,
                  }}
                >
                  STEP 01
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    my: 2,
                    // color: '#6d6d6d',
                  }}
                >
                  Contact Us & Share Details
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Call us at{' '}
                  <Link href="tel:+1(408) 444-7120" sx={{ color: '#0202ff' }}>
                    {' '}
                    (408) 444-7120
                  </Link>{' '}
                  and share your business & vehicle details. We’ll enter
                  everything into your Form 2290.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  px: 4,
                  backgroundColor: '#fff',
                  borderRadius: 6,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    backgroundColor: 'rgb(30, 190, 65, 0.5)',
                    display: 'inline-block',
                    p: ' 6px 15px',
                    borderRadius: 1.5,
                    fontWeight: 500,
                    color: '#2e2e2e',
                    my: 2,
                  }}
                >
                  STEP 02
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    my: 2,
                    // color: '#6d6d6d',
                  }}
                >
                  Authorize the form
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  After we prepare your return, you'll receive a link to
                  authorize/e-sign the form through{' '}
                  <Link
                    href="https://www.zeronevault.com/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    ZeroneVault
                  </Link>
                  . Review and approve it to continue your filing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  px: 4,
                  backgroundColor: '#fff',
                  borderRadius: 6,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    backgroundColor: 'rgb(30, 190, 65, 0.5)',
                    display: 'inline-block',
                    p: ' 6px 15px',
                    borderRadius: 1.5,
                    fontWeight: 500,
                    color: '#2e2e2e',
                    my: 2,
                  }}
                >
                  STEP 03
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 20, xs: 18 },
                    fontWeight: 600,
                    my: 2,
                    // color: '#6d6d6d',
                  }}
                >
                  E-File & Receive Your Schedule 1
                </Typography>
                <Typography variant="body1">
                  We electronically file your Form 2290 with the IRS. Once
                  accepted, your IRS watermarked Schedule 1 is delivered in
                  minutes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 12, sm: 12, xs: 12 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href="tel:+1(408) 444-7120"
                >
                  {' '}
                  Call Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Expert 2290 Phone Filing at an affordable price!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Save your valuable time by letting our HVUT experts complete
                your Form 2290 filing for you.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Box
                component="strong"
                sx={{
                  color: '#ffe400',
                  fontSize: { xs: 30, sm: 36, md: 48, lg: 60 },
                }}
              >
                $44.99
              </Box>
              /return
              <Typography
                variant="body2"
                sx={{ mt: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                Best Price in the Industry
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: 0,
        }}
        component="section"
      >
        <Container sx={{ maxWidth: '1200px !important' }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Information Required to File Form 2290 by Phone
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 22, md: 22, sm: 20, xs: 18 },
                  fontWeight: 400,
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                Have these details ready before you call — our expert will take
                about 7-10 minutes.
              </Typography>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/profile-business-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/profile-business-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/profile-business-icon.png"
                      alt="Business Name & Address"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Business Name & Address
                </Typography>
                <Typography variant="body1">
                  The full legal name and address of your business.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/ein-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/ein-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/ein-icon.png"
                      alt="Employer Identification Number"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Employer Identification Number
                </Typography>
                <Typography variant="body1">
                  Your 9-digit EIN issued by the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/calender-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/calender-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/calender-icon.png"
                      alt="First Used Month (FUM)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  First Used Month (FUM)
                </Typography>
                <Typography variant="body1">
                  The month your vehicle was first used in service on public
                  highways.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vin-vechicle-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vin-vechicle-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vin-vechicle-icon.png"
                      alt="Vehicle Identification Number"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Vehicle Identification Number
                </Typography>
                <Typography variant="body1">
                  Your vehicle's unique 17-character VIN number.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/goss-weight-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/goss-weight-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/goss-weight-icon.png"
                      alt="Taxable Gross Weight"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Taxable Gross Weight
                </Typography>
                <Typography variant="body1">
                  The total weight of your vehicle including maximum load
                  capacity.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ my: 5 }}>
          <Grid
            container
            spacing={2}
            m={0}
            mb={4}
            className="MuiGrid-root-width"
            flexDirection={{ xs: 'column-reverse', md: 'row' }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 3 }, mt: { xs: -3, md: 3 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Download Our Form 2290 Phone Filing Template
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                  }}
                >
                  Download our <span style={{ fontWeight: 600 }}>FREE</span>{' '}
                  Excel template, fill in the required info, and keep your
                  completed file ready before you call.
                </Typography>
                <Typography variant="body1">
                  We will prepare and submit your return to the IRS while you
                  are on the line.
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box> Fast and accurate filing by 2290 experts</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>Ideal for owner-operators and fleet owners</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Receive your{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        IRS-stamped Schedule 1
                      </span>{' '}
                      in minutes after acceptance.
                    </Box>
                  </li>
                </Box>

                <Box sx={{}}>
                  <Button
                    startIcon={<SimCardDownloadOutlinedIcon />}
                    onClick={() => setIsForm2290Template(true)}
                    sx={{
                      color: 'primary.contrastText',
                      fontWeight: 600,
                      px: 2.5,
                      py: 1.2,
                      fontSize: { xs: 14, sm: 18 },
                      textTransform: 'none',
                      borderRadius: '20px',
                      bgcolor: 'primary.main',
                      overflow: 'hidden',
                      position: 'relative',
                      transition: 'background-color 0.3s ease',

                      '& .MuiButton-startIcon': {
                        marginRight: '8px',
                        transition:
                          'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                      },

                      '& .MuiButton-startIcon svg': {
                        fontSize: '28px',
                      },

                      '& .button-text': {
                        display: 'inline-block',
                        minWidth: '150px',
                        transition:
                          'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                      },

                      '&:hover': {
                        bgcolor: '#1da94a',
                        color: 'secondary.contrastText',
                      },

                      '&:hover .button-text': {
                        transform: 'translateX(30px)',
                        opacity: 0,
                      },

                      '&:hover .MuiButton-startIcon': {
                        transform: 'translateX(100px)',
                      },
                    }}
                  >
                    <span className="button-text">Download Template</span>
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/f2290-excel-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/f2290-excel-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/f2290-excel-img.png"
                    alt="Download Our Form 2290 Phone Filing Template"
                    className="img-responsive"
                    loading="lazy"
                    width={600}
                    height={550}
                  />
                </picture>
              </Box>
              {/* <Typography
                variant="body1"
                onClick={() => {
                  setIsForm2290Template(true);
                }}
                sx={{
                  textAlign: 'center',
                  fontWeight: 600,
                  fontSize: { md: 18 },
                  mb: 4,
                  mt: -1.8,
                  cursor: 'pointer',
                  '&:hover': {
                    color: '#0202ff',
                  },
                }}
              >
                <SimCardDownloadOutlinedIcon sx={{ mb: -0.5 }} /> Download
                Template{' '}
              </Typography> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 }, justifyContent: 'center' }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="body2"
                sx={{
                  fontSize: 16,
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  mb: 1,
                }}
              >
                More Ways to File{' '}
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Prefer Chat or Email to File Your Form 2290?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontWeight: 400,
                  fontSize: { md: 19, sm: 18, xs: 17 },
                }}
              >
                Same expert help, your preferred channel
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} textAlign="center">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  minHeight: '100%',
                  borderRadius: 6,
                  backgroundColor: '#ffffff',
                  alignSelf: 'stretch',
                  justifyContent: 'space-between',
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  // border: '3px solid #626262',
                  textAlign: 'left',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/chat-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/chat-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/chat-icon.png"
                      alt="Chat with an Expert "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Chat with an Expert
                </Typography>

                <Typography variant="body1">
                  Start a live chat with our HVUT experts, and we'll handle your
                  2290 filing from start to finish.
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      {' '}
                      One-on-one assistance from experienced Form 2290 experts
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>Fast and secure filing from any device</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Ideal for truckers and fleet owners with busy schedules
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Receive your{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        IRS-stamped Schedule 1
                      </span>{' '}
                      as soon as it's accepted.
                    </Box>
                  </li>
                </Box>
                <Box
                  sx={{
                    mt: 1,
                  }}
                >
                  <Button
                    size="large"
                    onClick={openChat}
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    Start a Live Chat Now
                  </Button>
                  <Typography variant="body2" sx={{ fontWeight: 500, mt: 1 }}>
                    {' '}
                    Mon – Fri (9 AM to 5 PM CST){' '}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} textAlign="center">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  minHeight: '100%',
                  borderRadius: 6,
                  backgroundColor: '#ffffff',
                  alignSelf: 'stretch',
                  justifyContent: 'space-between',
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  // border: '3px solid #626262',
                  textAlign: 'left',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Email Your Template"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Email Your Template
                </Typography>

                <Typography variant="body1">
                  Send us your completed Excel file and our team handles your
                  HVUT filing, keeping you updated throughout.
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box> Simple and convenient — no account needed</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>Secure handling of all your documents</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>Expert review before IRS submission</Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        IRS-stamped Schedule 1
                      </span>{' '}
                      delivered straight to your inbox.
                    </Box>
                  </li>
                </Box>
                <Box
                  sx={{
                    mt: 1,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    onClick={() => {
                      setIsOpenPopUp(true);
                    }}
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=mobile2290`}
                  >
                    Email Us to File
                  </Button>
                  <Typography variant="body2" sx={{ fontWeight: 500, mt: 1 }}>
                    {' '}
                    Available 24/7
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
          mb: { xs: 4, sm: 8, md: 10 },
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                }}
              >
                Benefits of Filing 2290 Over the Phone with TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 19, sm: 18, xs: 17 },
                  textAlign: 'center',
                  justifyContent: 'center',
                }}
              >
                Filing support built for truckers — from single-truck operators
                to large fleet managers.
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vin-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vin-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vin-icon.png"
                      alt="Free VIN Correction"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Free VIN Correction
                </Typography>
                <Typography variant="body1">
                  Made a mistake with your Vehicle Identification Number (VIN)?
                  No problem. TaxZerone provides{' '}
                  <Link
                    href="/excise-tax/efile-irs-form-2290-vin-correction-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    free VIN corrections
                  </Link>
                  , helping you update without additional cost over the phone.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant Schedule 1 Delivery "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Schedule 1 Delivery
                </Typography>
                <Typography variant="body1">
                  Once the IRS accepts your Form 2290, you'll receive your
                  <Link
                    href="/resources/excise-tax/form-2290-schedule-1/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    stamped Schedule 1 in minutes
                  </Link>
                  . This proof of payment is essential for vehicle registration
                  and renewals.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="Free Retransmission"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Free Retransmission
                </Typography>
                <Typography variant="body1">
                  If your return is rejected by the IRS due to filing errors or
                  data issues, we'll correct and retransmit your return at no
                  additional charge.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/location-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/location-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/location-icon.png"
                      alt="Filing From Anywhere "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Filing From Anywhere
                </Typography>
                <Typography variant="body1">
                  Whether you're at home, in the office, or on the road, you can
                  file your Form 2290 over the phone without visiting an office.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="No Tax Knowledge Required "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  No Tax Knowledge Required
                </Typography>
                <Typography variant="body1">
                  You don't need to understand IRS HVUT tax forms or filing
                  requirements—simply provide your information, and we'll take
                  care of the rest.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Personalized Filing Assistance"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Personalized Filing Assistance
                </Typography>
                <Typography variant="body1">
                  Skip the confusion of filing on your own. Just answer the
                  questions over the phone and our experts will file your HVUT
                  form on your behalf.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 3 },
                }}
              >
                Hear From Truckers Who Trust TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Real stories from owner-operators and fleet managers across the
                country.
              </Typography>
              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
              >
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I filed my 2290 form by calling their support team. I
                        highly recommend them to any truck owner.{' '}
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                        <Typography
                          variant="body1"
                          sx={{
                            mt: 5,
                            fontWeight: 600,
                            textAlign: 'right',
                            mb: 0.8,
                          }}
                        >
                          - Zachary Bennett
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ mt: 0.5, textAlign: 'right' }}
                        >
                          Independent Truck Driver
                        </Typography>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Filing Form 2290 for our fleet used to take hours. With
                        a phone filing service, the process was incredibly
                        simple.{' '}
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, mt: 6, textAlign: 'right' }}
                    >
                      - Steven Young
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mt: 0.5, textAlign: 'right' }}
                    >
                      Fleet Manager
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      backgroundColor: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I was on the road and had no time to deal with filing. I
                        called their team and they handled everything over the
                        phone in just a few minutes.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, mt: 2, textAlign: 'right' }}
                    >
                      - Thomson Joe
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mt: 0.5, textAlign: 'right' }}
                    >
                      Owner Operator
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to File? Call us Now
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Get your Schedule 1 today — No forms, No confusion, No waiting.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 1 },
              mb: { xs: 0, md: 0 },
              transition: 'all 0.3s ease 0s',
              display: { xs: 'inline-flex', sm: 'inline-flex' },
              '&:hover, &active': {
                transform: 'scale(1.1)',
              },
            }}
            className="btn-primary"
            href="tel:+1(408) 444-7120"
          >
            Call Now
          </Button>
        </Box>
      </Box>

      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="phone-filing-faqs"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="phone-filing-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How do I pay the filing fee for my 2290 phone filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mb: 1, mt: 1 }}>
                      After our expert prepares your Form 2290, you'll receive
                      an email to review and authorize your return. The same
                      email will also contain your filing fee details and a
                      secure payment link. Once payment is completed, we will
                      transmit your Form 2290 to the IRS on your behalf.
                    </Typography>
                    <Alert
                      icon={false}
                      severity="warning"
                      sx={{
                        mt: 0,
                        mb: 0,
                        borderLeft: '3px solid rgb(102, 60, 0)',
                      }}
                    >
                      <b> Note:</b> TaxZerone will never ask for your card
                      details directly.
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. How soon will I receive my Schedule 1?
                </Typography>

                <Box
                  sx={{ mt: 1 }}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Once your HVUT filing is accepted by the IRS, your stamped
                    Schedule 1 is emailed to you immediately. The processing
                    time is the same as regular e-filing.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. How long does a phone filing process take?
                </Typography>

                <Box
                  sx={{ mt: 1 }}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    The{' '}
                    <Link
                      href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 2290{' '}
                    </Link>{' '}
                    phone filing process takes typically 7-10 minutes, depending
                    on the number of vehicles being reported. Having your
                    details handy can help speed up the process.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                  mt: 1,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Is phone filing available for both new and returning
                  filers?
                </Typography>

                <Box
                  sx={{ mt: 1 }}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Yes, Heavy Vehicle Use Tax (HVUT) phone filing is available
                    for both first-time and returning filers. Whether you're
                    filing your HVUT return for the first time or renewing an
                    existing fleet, TaxZerone will handle your complete filing.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Is filing Form 2290 with TaxZerone by phone secure?
                </Typography>

                <Box
                  sx={{ mt: 1 }}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Yes, as an IRS-authorized e-file provider, your business and
                    vehicle information is transmitted using secure systems
                    designed to protect your data — the same level of security
                    as online e-filing.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-2290/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FileForm2290Phone;
